<div
  *ngIf="category$ | async as category"
  class="col-sm category-name"
  [attr.data-testing-id]="'category-' + category.uniqueId"
>
  <a [routerLink]="category | ishCategoryRoute">
    <p>{{ category.name }}</p>
  </a>
</div>
